import { IconWarehouse, IconDoorOpen, IconShoppingCart, IconClock, IconWrench } from './icons';
import { DOOR_TO_DOOR_IMG, STAND_INSTALL_DISMANTLE_IMG, STAND_PURCHASE_IMG, STAND_RENTAL_IMG, VIA_WAREHOUSE_IMG } from './image';

export const PASSWORD_REGEX: RegExp = /^(?=.*[a-zA-Z])(?=.*\d)/
// export const API_BASE_URL: string = "http://localhost:8000/api/v1";
// export const API_BASE_URL: string = 'https://dev-portal-sitelog.devkraft.in/api/v1';
export const API_BASE_URL: string = 'https://enquiryportal.siteeventlogistics.com/api/v1';
export const API_TIMEOUT: number = 5 * 60 * 1000; // 5 minutes in milliseconds

export const CHECK_INTERVAL_MS = 5000;

// Date format used in admin tables
export const DATE_FORMAT_DATETIME = 'DD/MM/YYYY hh:mm A';

// Program Manager - default address structure for member form
export const DEFAULT_MEMBER_ADDRESS = {
  address_line_1: '',
  city: '',
  state: '',
  country: '',
  postal_code: '',
};

export const ENQUIRY_STATUS_DRAFT = "Draft";
export const ENQUIRY_STATUS = ['Submitted', 'Submitted + Paid', 'Submitted + Pre Alert Filled', 'Submitted + Pre Alert Filled + Return Pre Alert Filled'];
export const DRAFT_STATUS = ['Draft', 'Submitted + Payment Pending'];

export const ENQUIRY_PANELS_KEYS: Record<string, string> = {
  exhibitor: "exhibitor",
  event: "event",
  service: "service",
  intention: "intention",
  collection: "collection",
  shipment: "shipment",
  return: "return",
  insurance: "insurance",
  onsite: "onsite",
}

export const SHIPMENT_INTENTION_KEYS: Record<string, string> = {
  intention: "intention",
  collection: "collection",
  shipment: "shipment",
  return: "return",
  insurance: "insurance",
  onsite: "onsite",
}

export const SERVICE_KEYS: any = [
  "stand_purchase",
  "stand_rental",
  "stand_install_and_dismantle",
  "freight_(door_to_door)",
  "freight_(via_warehouse)",
]

export const SERVICES_KEYS: any[] = [
  {
    id: "80bc43fb-537c-4640-8cad-304a5060bc31",
    service_name: "Stand Purchase",
    service_key: "stand_purchase",
  },
  {
    id: "5b7d466a-fb15-425c-bcec-e4e084db53bf",
    service_name: "Stand Rental",
    service_key: "stand_rental",
  },
  {
    id: "1ad33cad-d146-420e-8458-6808ed823083",
    service_name: "Stand Install & Dismantle",
    service_key: "stand_install_and_dismantle",
  },
  {
    id: "87dec731-d3bf-428b-bb95-f0db8c1dddcf",
    service_name: "You ship to our warehouse",
    service_key: "freight_(via_warehouse)",
  },
  {
    id: "f7beefa4-279e-44ab-9b89-95330025ac3d",
    service_name: "We collect from you",
    service_key: "freight_(door_to_door)",
  },
  {
    id: "e939296c-389e-474f-b7a5-82b388011005",
    service_name: "Other",
    service_key: "OTHER",
  },
]

export const FREIGHT_METHODS_ONE = {
  id: 'freight_(via_warehouse)',
  icon: IconWarehouse,
  title: 'You ship to our warehouse',
  description: 'Ship your items to us to address: ',
  img: VIA_WAREHOUSE_IMG,
  titleInfo: 'You ship to our warehouse',
}

export const FREIGHT_METHODS_TWO = {
  id: 'freight_(door_to_door)',
  icon: IconDoorOpen,
  title: 'We collect from you',
  description: 'We pick up from your location and handle end-to-end delivery.',
  img: DOOR_TO_DOOR_IMG,
  titleInfo: 'We collect from you',
}

export const FREIGHT_METHODS = [
  {
    id: 'freight_(via_warehouse)',
    icon: IconWarehouse,
    title: 'You ship to our warehouse',
    description: 'Ship your items to us to address: ',
    img: VIA_WAREHOUSE_IMG,
    titleInfo: 'You ship to our warehouse',
  },
  {
    id: 'freight_(door_to_door)',
    icon: IconDoorOpen,
    title: 'We collect from you',
    description: 'We pick up from your location and <br /> handle end-to-end delivery.',
    img: DOOR_TO_DOOR_IMG,
  },
];

export const STAND_OPTIONS: any = [
  {
    id: 'stand_purchase',
    icon: IconShoppingCart,
    title: 'Stand Purchase',
    description: 'Buy ready stands directly at the event venue.',
    img: STAND_PURCHASE_IMG,
  },
  {
    id: 'stand_rental',
    icon: IconClock,
    title: 'Stand Rental',
    description: 'Rent high-quality stands for any event setup.',
    img: STAND_RENTAL_IMG,
  },
  {
    id: 'stand_install_and_dismantle',
    icon: IconWrench,
    title: 'Stand Install & Dismantle',
    description: 'Professional stand setup and teardown at the venue.',
    img: STAND_INSTALL_DISMANTLE_IMG,
  }
];


export const STATUS_LIST = [{ label: 'Draft', value: 'draft' }, { label: 'Submitted', value: 'submitted' }, { label: 'All', value: '' }]

export const SHIPMENT_STATUS_OPTIONS = [
  { label: 'COMPLETE', value: 'COMPLETE' },
  { label: 'IN TRANSIT', value: 'IN TRANSIT' },
  { label: 'NO MOVEMENT', value: 'NO MOVEMENT' },
  { label: 'AT ADVANCED WAREHOUSE', value: 'AT ADVANCED WAREHOUSE' },
  { label: 'ENQUIREY', value: 'ENQUIREY' },
  { label: 'PENDING DOCS', value: 'PENDING DOCS' },
  { label: 'PENDING COLLECTION', value: 'PENDING COLLECTION' },
  { label: 'CUSTOMS ISSUE', value: 'CUSTOMS ISSUE' },
  { label: 'STORAGE', value: 'STORAGE' },
];


export const PRICE_RANGE_CALCULATION_KG: any = [
  {
    region: "US_HANSON_WADE",
    metaData: [
      {
        category: "Small",
        weightRange: [0, 90.7185],
        baseRate: 440,
        extraCharge: false,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Medium",
        weightRange: [90.7186, 453.5924],
        baseRate: 440,
        extraCharge: true,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeRate: 4.4092,
        extraChargeSchema: []
      },
      {
        category: "Large",
        weightRange: [453.5925, 907.1847],
        baseRate: 440,
        extraCharge: true,
        extraChargeRate: 3.8581,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Very Large",
        weightRange: [907.1848, 100000000000],
        baseRate: 440,
        extraCharge: true,
        extraChargeRate: 3.3069,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      }
    ]
  },
  {
    region: "USA",
    metaData: [
      {
        category: "Small",
        weightRange: [0, 18.1437],
        baseRate: 445,
        extraCharge: false,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Medium",
        weightRange: [18.1438, 90.7185], //18.1438–90.7185 kg
        baseRate: 445,
        extraCharge: false,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Large",
        weightRange: [90.7186, 100000000000],  //90.7186–100000000000 kg
        baseRate: 445,
        extraCharge: true,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeRate: 4.4092, // $4.4092/kg over 90.7186 kg
        extraChargeSchema: []
      }
    ]
  },
  {
    region: "US_OXFORD_GLOBAL",
    metaData: [
      {
        category: "Small",
        weightRange: [0, 18.1437], //0–18.1437 kg
        baseRate: 245,
        extraCharge: false,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Medium",
        weightRange: [18.1438, 90.7185], //18.1438–90.7185 kg
        baseRate: 595,
        extraCharge: false,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Large",
        weightRange: [90.7186, 453.5924], //90.7186–453.5924 kg
        baseRate: 595,
        extraCharge: true,
        extraChargeRate: 4.4092, // $4.4092/kg over 90.7186 kg
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Very Large",
        weightRange: [453.5925, 100000000000], // 453.5925+ kg
        baseRate: 595,
        extraCharge: true,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: [ // $4.4092/kg (91.1721–453.5924 kg) + $2.2046/kg over 453.5924 kg
          {
            range: [90.7186, 453.5924],
            rate: 4.4092,
          },
          {
            range: [453.5925, 100000000000],
            rate: 2.2046,
          }
        ]
      }
    ]
  },
  {
    region: "OTHERS",
    metaData: [
      {
        category: "Small",
        weightRange: [0, 22.6796],
        baseRate: 595,
        extraCharge: false,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Medium",
        weightRange: [22.6797, 90.7185],
        baseRate: 695,
        extraCharge: false,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Large",
        weightRange: [90.7186, 453.5924],
        baseRate: 695,
        extraCharge: true,
        extraChargeRate: 4.4092,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Very Large",
        weightRange: [453.5925, 907.1847],
        baseRate: 695,
        extraCharge: true,
        extraChargeRate: 3.8581,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Ultra Large",
        weightRange: [907.1848, 100000000000],
        baseRate: 695,
        extraCharge: true,
        extraChargeRate: 3.3069,
        currencySymbol: "$",
        fileFee: 55,
        extraChargeSchema: []
      }
    ]
  },
  {
    region: "EUROPE",
    metaData: [
      {
        category: "Small",
        weightRange: [0.1, 20.99], //0–20 kg
        baseRate: 445,
        extraCharge: false,
        currencySymbol: "€",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Medium",
        weightRange: [21, 100], //21–100 kg
        baseRate: 495,
        extraCharge: false,
        currencySymbol: "€",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Large",
        weightRange: [100.01, 300], //101–10000000kg
        baseRate: 495,
        extraCharge: true,
        extraChargeRate: 2, // €1/kg over 100
        currencySymbol: "€",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Very Large",
        weightRange: [300.01, 600],
        baseRate: 495,
        extraCharge: true,
        extraChargeRate: 1.5, // €1.5/kg over 300
        currencySymbol: "€",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Ultra Large",
        weightRange: [600.01, 100000000000],
        baseRate: 495,
        extraCharge: true,
        extraChargeRate: 1,
        currencySymbol: "€",
        fileFee: 55,
        extraChargeSchema: []
      }
    ]
  },
  {
    region: "UK",
    metaData: [
      {
        category: "Small",
        weightRange: [0, 20],
        baseRate: 395,
        extraCharge: false,
        currencySymbol: "£",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Medium",
        weightRange: [20.01, 100],
        baseRate: 440,
        extraCharge: false,
        currencySymbol: "£",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Large",
        weightRange: [100.01, 300],
        baseRate: 440,
        extraCharge: true,
        extraChargeRate: 2,
        currencySymbol: "£",
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Very Large",
        weightRange: [300.01, 600],
        baseRate: 440,
        extraCharge: true,
        currencySymbol: "£",
        extraChargeRate: 1.50,
        fileFee: 55,
        extraChargeSchema: []
      },
      {
        category: "Ultra Large",
        weightRange: [600.01, 100000000000],
        baseRate: 440,
        extraCharge: true,
        currencySymbol: "£",
        extraChargeRate: 1,
        fileFee: 55,
        extraChargeSchema: []
      }
    ]
  }

]

export const CBM_PRICE_RANGE_CALCULATION: any = [
  {
    region: "OTHERS",
    metaData: {
      pricePCBM: 90,
      currencySymbol: "$",
    }
  },
  {
    region: "USA",
    metaData: {
      pricePCBM: 90,
      currencySymbol: "$",
    }
  },
  {
    region: "UK",
    metaData: {
      pricePCBM: 90,
      currencySymbol: "£",
    }
  },
  {
    region: "EUROPE",
    metaData: {
      pricePCBM: 90,
      currencySymbol: "€",
    }
  },
  {
    region: "US_HANSON_WADE",
    metaData: {
      pricePCBM: 90,
      currencySymbol: "$"
    }
  },
  {
    region: "US_OXFORD_GLOBAL",
    metaData: {
      pricePCBM: 90,
      currencySymbol: "$"
    }
  }
]

export const CURRENCY_SYMBOL: any = {
  EUROPE: "€",
  UK: "£",
  USA: "$",
  US_HANSON_WADE: "$",
  US_OXFORD_GLOBAL: "$",
  USA_OXFORD_GLOBAL: "$",
  OTHERS: "$"
}

export const CURRENCY_CODE: any = {
  EUROPE: "EUR",
  UK: "GBP",
  USA: "USD",
  US_HANSON_WADE: "USD",
  US_OXFORD_GLOBAL: "USD",
  USA_OXFORD_GLOBAL: "USD",
  OTHERS: "USD"
}

export const CURRENCY_CODE_TO_SYMBOL: any = {
  EUR: "€",
  GBP: "£",
  USD: "$",
  OTHERS: "$"
}

export const US_REGIONS: string[] = ["USA", "US_HANSON_WADE", "US_OXFORD_GLOBAL", "OTHERS"]

export const TOUR_CONTENT: any = {
  freight_only: `
  **Please complete the required information before clicking ‘Next’. You can navigate between sections using the tabs at the top. Start by filling in the Onsite and Shipping details. When adding a package or shipment, ensure the dimensions are accurate. After completing each section, click ‘Save’. You may add additional packages or shipments as needed.

  Once all entries are complete, click ‘Next’—a green checkmark will confirm the section is complete. Continue this process through each tab. After finishing the third tab (Insurance and Others), click the blue ‘Submit’ button to add your selections to your basket. You may then proceed to payment.**
  `,
  stand_only: `
  **Please select the stand you would like and add it to your basket. You may then proceed to payment. A member of our team will contact you shortly to discuss any relevant details, including graphics, if you choose to buy or rent a stand from us.**
  `,
  freight_and_stand: `
    ## Instructions

    ### Freight + Stand

    **Please complete the required information before clicking ‘Next’. You can navigate between sections using the tabs at the top. Start by filling in the Onsite and Shipping details. When adding a package or shipment, ensure the dimensions are accurate. After completing each section, click ‘Save’. You may add additional packages or shipments as needed.**

    **Once all entries are complete, click ‘Next’—a green checkmark will confirm the section is complete. Continue this process through each tab. After finishing the third tab (Insurance and Others), click the blue ‘Submit’ button to add your selections to your basket. You may then proceed to payment.**

    ---

    **Additionally, please select the stand you would like and add it to your basket. You may then proceed to payment. A member of our team will contact you shortly to discuss any relevant details, including graphics, if you choose to buy or rent a stand from us.**
  `,
}

export const TRACKING_STATUS_OPTIONS = ([
  { label: 'Created', value: 'Created' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Transit', value: 'Transit' },
  { label: 'Delivered', value: 'Delivered' },
]);